// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'Store';

// Base selectors
const selectFolderListState = (state: RootState) => state.folderList;

// Basic state selectors
export const selectFolderList = createSelector(
  [selectFolderListState],
  (folderListState) => folderListState.folderList,
);

export const selectFolderListLoading = createSelector(
  [selectFolderListState],
  (folderListState) => folderListState.foldersLoading,
);

export const selectProjectsInFolder = createSelector(
  [selectFolderListState],
  (folderListState) => folderListState.projectsInFolder,
);

export const selectSelectedFolder = createSelector(
  [selectFolderListState],
  (folderListState) => folderListState.selectedFolder,
);

// Single source of truth for "find a folder by id within an already-loaded folder list" -
// used by the project detail breadcrumb, the search-result folder badge, and folder browsing.
export const findFolderById = (folderList: IFolder[], folderId?: string): IFolder | undefined => (
  folderId ? folderList.find((folder) => folder._id === folderId) : undefined
);
